<div class="header">
  <p-button
    label="Home"
    icon="pi pi-arrow-left"
    [text]="true"
    severity="primary"
    (click)="onBackClicked()"
  />
</div>
@if (hss$ | async; as hss) {
  <div class="card-container">
    <div class="container">
      <!-- Jump to buttons -->
      <div class="jump-to-container">
        @if (afIndices.length > 0) {
          <p-button
            styleClass="jump-btn"
            label="AF"
            (click)="nextAf()"
            [badge]="getAfBadge()"
            badgeClass="p-badge-danger"
            [rounded]="true"
            [outlined]="true"
          ></p-button>
        } @else {
          <p-button
            styleClass="jump-btn"
            label="AF"
            [rounded]="true"
            [outlined]="true"
            [disabled]="true"
          ></p-button>
        }
        @if (roIndices.length > 0) {
          <p-button
            styleClass="jump-btn"
            label="RO"
            (click)="nextRo()"
            [badge]="getRoBadge()"
            badgeClass="p-badge-danger"
            [rounded]="true"
            [outlined]="true"
          ></p-button>
        } @else {
          <p-button
            styleClass="jump-btn"
            label="RO"
            [rounded]="true"
            [outlined]="true"
            [disabled]="true"
          ></p-button>
        }
        @if (cxlIndices.length > 0) {
          <p-button
            styleClass="jump-btn"
            label="CXLD"
            (click)="nextCxl()"
            [badge]="getCxlBadge()"
            badgeClass="p-badge-danger"
            [rounded]="true"
            [outlined]="true"
          ></p-button>
        } @else {
          <p-button
            styleClass="jump-btn"
            label="CXLD"
            [rounded]="true"
            [outlined]="true"
            [disabled]="true"
          ></p-button>
        }
        @if (pilotIndices.length > 0) {
          <p-button
            styleClass="jump-btn"
            label="Crew"
            (click)="nextPilot()"
            [badge]="getPilotBadge()"
            badgeClass="p-badge-danger"
            [rounded]="true"
            [outlined]="true"
          ></p-button>
        } @else {
          <p-button
            styleClass="jump-btn"
            label="Crew"
            [rounded]="true"
            [outlined]="true"
            [disabled]="true"
          ></p-button>
        }
      </div>
      <!-- Navigation buttons -->
      <div class="nav-container nav-buttons">
        <div>
          <p-button
            icon="pi pi-fast-backward"
            styleClass="text-sm"
            [text]="true"
            (click)="updateIndex = 0"
            [disabled]="updateIndex === 0"
          ></p-button>
          <p-button
            icon="pi pi-chevron-left"
            [text]="true"
            (click)="decrementUpdateIndex()"
            [disabled]="updateIndex === 0"
          ></p-button>
        </div>
        <div class="jump-to-label">
          {{ updateIndex + 1 }} of {{ updatesCount }}
        </div>
        <div>
          <p-button
            icon="pi pi-chevron-right"
            [text]="true"
            (click)="incrementUpdateIndex()"
            [disabled]="updateIndex >= updatesCount - 1"
          ></p-button>
          <p-button
            icon="pi pi-fast-forward"
            styleClass="text-lg"
            [text]="true"
            (click)="updateIndex = updatesCount - 1"
            [disabled]="updateIndex >= updatesCount - 1"
          ></p-button>
        </div>
      </div>
      <!-- Navigation slider -->
      <div class="nav-container">
        <div class="slider-container">
          <p-slider
            [(ngModel)]="updateIndex"
            [max]="updatesCount - 1"
            [animate]="true"
            class="slider"
          ></p-slider>
          <div class="timestamp">
            <span
              >{{ getHbtTimestamp(hss.timestamp, hss.header.base.text) }} ({{
                hss.header.base.text
              }})
            </span>
          </div>
        </div>
      </div>
      <!-- <p-divider class="width-100"></p-divider> -->
      <app-hss-builder
        [hss]="hss"
        [theme]="globalService.theme()"
        [enhanced]="enhancedMode"
        [index]="updateIndex"
        [fontSizeOffset]="fontSizeOffset"
        [stationTimeZones]="stationTimeZones()"
        [raps]="raps()"
      ></app-hss-builder>
      @if (globalService.isAdmin()) {
        <div class="update-id">ID: {{ hss.sequenceUpdateId }}</div>
      }
      <p-divider class="width-100"></p-divider>
      <div class="enhanced-container">
        <div class="colorize-container">
          <div class="enhanced-label">Colorize</div>
          <p-inputSwitch [(ngModel)]="enhancedMode"></p-inputSwitch>
        </div>
        <div class="text-size-container">
          <p-button
            icon="pi pi-search-minus"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="decreaseFontSize()"
          ></p-button>
          <p-button
            icon="pi pi-search-plus"
            [rounded]="true"
            [text]="true"
            severity="primary"
            (click)="increaseFontSize()"
          ></p-button>
        </div>
      </div>
    </div>
    <app-last-updated
      class="width-100"
      [lastUpdated]="historyService.lastUpdated()"
      [refreshing]="isLoading()"
      (refresh)="onRefreshClick()"
    />
  </div>
  <div class="card-container">
    <div class="pay-container">
      <div class="pay-item">
        <div class="pay-value">{{ startingTl() }}</div>
        <div class="pay-label">Starting Pay</div>
      </div>
      <div class="pay-item">
        <div class="pay-value">{{ endingTl() }}</div>
        <div class="pay-label">Ending Pay</div>
      </div>
      <div class="pay-item">
        <div
          class="pay-value"
          [class.pos-change]="diffTl() !== '0' && !diffTl().startsWith('-')"
          [class.neg-change]="diffTl() !== '0' && diffTl().startsWith('-')"
        >
          {{ diffTl() }}
        </div>
        <div class="pay-label">Change</div>
      </div>
    </div>
  </div>
  <app-accordion title="Pilot History" class="width-100">
    <div class="emp-history-container">
      <p-timeline [value]="empHistory().items">
        <ng-template pTemplate="content" let-event>
          <div
            class="emp-date text-xs clickable"
            (click)="onPilotHistoryClick(event.index)"
          >
            {{ event.date }}
          </div>
          <div
            class="emp-time text-xs clickable"
            (click)="onPilotHistoryClick(event.index)"
          >
            {{ event.time }}
          </div>
        </ng-template>
        <ng-template pTemplate="opposite" let-event>
          <div class="text-sm">
            <span
              class="emp-name clickable"
              [class]="event.name === 'OPEN' ? 'open' : 'assigned'"
              (click)="onPilotHistoryClick(event.index)"
              >{{ event.name }}</span
            >
            @if (event.addCode !== "") {
              <span class="opacity-5"> (</span>
              <span
                class="clickable-code"
                (click)="description.toggle($event)"
                >{{ event.addCode }}</span
              >
              <span class="opacity-5">)</span>
              <p-overlayPanel #description>
                <div>{{ getCodeDescription(event.addCode, "add") }}</div>
              </p-overlayPanel>
            }
            @if (event.removeCode.trim() !== "" && globalService.isAdmin()) {
              <span class="opacity-5"> (</span>
              <span
                class="clickable-code"
                (click)="description.toggle($event)"
                >{{ event.removeCode }}</span
              >
              <span class="opacity-5">)</span>
              <p-overlayPanel #description>
                <div>{{ getCodeDescription(event.removeCode, "remove") }}</div>
              </p-overlayPanel>
            }
          </div>
          @if (event.empNum !== "0") {
            <div class="emp-num text-xs">
              {{ event.empNum }}
            </div>
          }
        </ng-template>
      </p-timeline>
      @if (globalService.isAdmin()) {
        <div class="flex-center text-sm opacity-5 text-center mt-32">
          Note: Remove codes are visible because you are an admin user.
        </div>
      }
    </div>
  </app-accordion>
} @else {
  @if (!isLoading()) {
    <!-- If no HSS and not loading, sequence not found. -->
    <div class="not-found">Sequence Not Found</div>
  }
  @if (isLoading()) {
    <div class="spinner-container">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
}
